import React from 'react';
import Button from 'tradevan-ui/Button';

export const onPdfPrint = (file: string) => (): void => {
  const pdfFrame = document.createElement('iframe');
  pdfFrame.style.visibility = 'hidden';
  pdfFrame.src = file;
  document.body.appendChild(pdfFrame);
  pdfFrame?.contentWindow?.focus();
  pdfFrame?.contentWindow?.print();
};

const PDFPrinter = (props: { file: string }): JSX.Element => {
  const { file } = props;
  return (
    <Button color="secondary" onClick={onPdfPrint(file)}>
      列印
    </Button>
  );
};

export default PDFPrinter;
